import { isAuthenticated } from 'modules/common/permissions';

import PartLibraryPage from '../entry';
import { initPartLibraryPage } from './sagas';

export default [
  {
    component: PartLibraryPage,
    exact: true,
    name: 'parts',
    path: '/parts',
    helpId: 'parts',
    permissions: [isAuthenticated],
    saga: initPartLibraryPage,
  },
];
